import * as types from "../../Action/type";

const initialState = {
    loading: false,
    page: 'email',
    error: null,
    newPass: false
}
const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_LOGIN_REQUEST:
            return { ...state, loading: true, error: null };
        case types.FETCH_FORGET_SUCCESS:
            console.log("forget reducer:", action.payload)
            return {
                ...state,
                page: action.payload,
                loading: false,
            };
        case types.FETCH_CODE_SUCCESS:
            console.log("forget reducer:", action.payload)
            return {
                ...state,
                page: action.payload,
                loading: false,
            };
        case types.FETCH_NEWPASS_SUCCESS:
            console.log("forget reducer:", action.payload)
            return {
                ...state,
                newPass: true,
                loading: false,
            };

        default:
            return state;
    }

}
export default AuthReducer;